export default "__VITE_ASSET__4e6fd2ee__"